import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Text,
  Table,
  Tr,
  Th,
  Thead,
  Tbody,
  Td
} from "@chakra-ui/react";
import {Col,Form,Row} from "react-bootstrap";

import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { GetState, GetCity } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { AiFillDelete, AiOutlineUpload } from "react-icons/ai";
import { FaPlusCircle } from "react-icons/fa";
import {
  companyIdOption,
  gstIdOption,
  industryType,
} from "./defaultSelectData";
import { fetchAsyncCreateOrganization } from "redux/organizationSlice";
import { fetchAsyncUpdateOrganizaion } from "redux/organizationSlice";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import {
  findStateByGstCode,
  indiaStateOptions,
} from "../Vendors/customFieldData";
import VendorCustomSelect from "../Vendors/VendorCustomSelect";
import {
  ACCOUNT_NUMBER_REGEX,
  EMAIL_REGEX,
  GST_REGEX,
  IFSC_REGEX,
  MAX_GST_LENGTH,
  MAX_IFSC_LENGTH,
  MAX_PAN_LENGTH,
  PAN_REGEX,
  PHONE_REGEX,
} from "../regexPatterns";
import orgJson from "components/jsonData/orgnization.json";
import CustomPopover from "components/customPopover/customPopover";
import axios from "axios";
import InputFormControl from "../component/inputFormControl";
import SelectField from "../component/selectField";
import TextAreaField from "../component/textAreaField";
import CheckboxField from "../component/checkboxField";
import RadioField from "../component/radioField";

const OrgnizationProfileForm = ({
  isEditForm,
  editItem,
  handleRefresh,
  loading,
}) => {
  const formState = {
    organizationName: "",
    industry: {},
    isBnk:false,
    address: {
      street1: "",
      street2: "",
      state: {},
      city: {},
      zipcode: "",
      phone: "",
      email: "",
    },
    website: "",
    companyType: {},
    companyId: "",
    gstType: {},
    gstNumber: "",
    panNumber: "",
    placeOfService: {},
    termsAndConditions: "",
    footerText: "",
    salesTC:"",
    salesFooterText:"",
    proformaTC:"",
    proformaFooterText:"",
    bnk:{
      typ:'',
      hol:"",
      name:"",
      bch:"",
      ifc:"",
    }

  };
  const [formData, setFormData] = useState(formState);
  const [selectedFile, setSelectedFile] = useState("");
  const [fileName,setFileName] = useState("");
  const [additionalField, setAdditionalField] = useState([
    {
      lab: "",
      val: "",
    },
  ]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const { addToast } = useToasts();

  useEffect(() => {
    GetState(101).then((states) => {
      setStateList(states);
    });
  }, []);

  const fillEditData = async(item)=>{
    const indus = industryType.find((ind)=>ind.id === item?.ind)
    const gType = gstIdOption.find((gst)=>gst.id === item?.gstTyp)
    const cType = companyIdOption.find((com)=>com.id === item?.cpTyp)
    const pos = indiaStateOptions.find((opt)=>opt.id === item?.pos)
   
    if (item) {
      const editData = item;
      const existData = {
        organizationName: editData?.name,
        isBnk:editData?.isBnk,
        industry: indus || {},
        address: {
          street1: editData?.add?.s1,
          street2: editData?.add?.s2,
          state: {},
          city: {},
          zipcode: editData?.add?.pin,
          phone: editData?.add?.ph,
          email: editData?.add?.mail,
        },
        website: editData?.web,
        companyType: cType,
        companyId: editData?.cpId,
        gstType: gType,
        gstNumber: editData?.gstNo,
        panNumber: editData?.pnNo,
        placeOfService: pos,
        termsAndConditions: editData?.tc,
        footerText: editData?.fTxt,
        salesTC:editData?.stc,
        salesFooterText:editData?.sFtxt,
        proformaTC:editData?.pfTc,
        proformaFooterText:editData?.pfFtxt,
        bnk:{
          ...editData?.bnk,
          hol:editData?.bnk?.name || editData?.name
        }

      };
      if(stateList && stateList.length > 0){
        existData.address.state = stateList.find((opt)=> opt.id === item?.add?.st);
        const state = existData?.address?.state;
        if(state && state.id){
          await GetCity(101, state.id).then((result) => {
            if(result){
              setCityList(result);
              existData.address.city = result.find((opt)=> opt.id === item?.add?.ct)
            }
          });
        }
      }
      setFormData(existData);
      setAdditionalField(editData?.adFld);
      if(item.lgo){
        const logoKey = item.lgo.key;
        const fname = logoKey.split('/').pop();
        setFileName(fname)

      }
    }
  }
  useEffect(() => {
    if (editItem && editItem?.length > 0) {
      fillEditData(editItem[0])
    }
  }, [editItem,stateList]);

  const handleStateChange = (state) => {
    if (state) {
      GetCity(101, state.id).then((result) => {
        setCityList(result);
      });

      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev?.address,
          state: state,
        },
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.organizationName)
      newErrors.organizationName = orgJson.required.orgName;
    if (!formData.industry?.value)
      newErrors.industry = orgJson.required.industry;
    if (formData.address.email && !EMAIL_REGEX.test(formData.address.email)) {
      newErrors.email = orgJson.error.email;
    }
    if (formData.address.phone && !PHONE_REGEX.test(formData.address.phone)) {
      newErrors.phone = orgJson.error.phone;
    }
    if (formData.gstNumber && !GST_REGEX.test(formData.gstNumber)) {
      newErrors.gstNumber = orgJson.error.gst;
    }
    if (formData?.panNumber && !PAN_REGEX.test(formData.panNumber)) {
      newErrors.panNumber = orgJson.error.pan;
    }
    if(formData?.bnk?.typ === "manual"){
      if (formData.bnk?.acNo && !ACCOUNT_NUMBER_REGEX.test(formData?.bnk?.acNo)) {
        newErrors.acNo = orgJson.error.accNumber;
      }
      if (formData?.bnk?.ifc && !IFSC_REGEX.test(formData?.bnk?.ifc)) {
        newErrors.ifc = orgJson.error.ifsc;
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const fetchBranchDetails = async () => {
    const { ifc } = formData?.bnk;
    const codeToFetch = ifc;
    if (!codeToFetch) return;

    let updatedFormData = formData;
    try {
      const response = await axios.get(`https://ifsc.razorpay.com/${codeToFetch}`);
      const { BANK, BRANCH } = response.data;
      updatedFormData = {
        ...formData,
       bnk: { 
        ...formData.bnk,
        name: BANK,
        bch: BRANCH,
      }
    }
    } catch (error) {
      updatedFormData = {
        ...formData,
       bnk: { 
        ...formData.bnk,
        name:"",
        bch: "",
      },
    }
    }
    setFormData(updatedFormData)
  };
  const handleBlur = () => {
    if (IFSC_REGEX.test(formData?.bnk?.ifc)) {
      fetchBranchDetails();
    } else {
      setFormData((prev) => ({
        ...prev,
        bankName: "",
        branchName: "",
        
      }));
    }
  };

  const handleChangeBank = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if(name !== 'typ' && name !== 'isBnk' && name === "ifc"){
        formattedValue = value.toUpperCase();
        if(name === "ifc" &&  formattedValue.length > MAX_IFSC_LENGTH ) {
          return 
        }
    }
    if (name === "ifc") {
      if (!formattedValue || IFSC_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, ifc: "" })); 
      } 
      else{
        setErrors((prev) => ({ ...prev, ifc: orgJson.error.ifsc })); 
      }
    }
    if (name === "acNo") {
      if (!formattedValue || ACCOUNT_NUMBER_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, acNo: "" })); 
      } 
      else{
        setErrors((prev) => ({ ...prev, acNo: orgJson.error.accNumber })); 
      }
    }
    const updatedFormData = {
        ...formData,
        ...(name === 'isBnk' 
            ? { isBnk: !formData.isBnk } 
            : { bnk: { ...formData.bnk, [name]: formattedValue } })
    };
    setFormData(updatedFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "panNumber" || name === "gstNumber" || name === "companyId") {
      formattedValue = value.toUpperCase();
      if (name === "panNumber" && formattedValue.length > MAX_PAN_LENGTH) {
        return;
      }
      if (name === "gstNumber" && formattedValue.length > MAX_GST_LENGTH) {
        return;
      }

      if (name === "gstNumber" && GST_REGEX.test(formattedValue)) {
        const extractedPan = formattedValue.substring(2, 12);
        const stateCode = formattedValue.substring(0, 2);
        const state = findStateByGstCode(stateCode) || "";
        setFormData((prev) => ({
          ...prev,
          panNumber: extractedPan,
          placeOfService: state,
        }));
      }
    } else if (name === "email") {
      formattedValue = value.toLowerCase();
    } else if (!['website','footerText','termsAndConditions','salesTC','salesFooterText','proformaTC','proformaFooterText'].includes(name)) {
      formattedValue = toCamelCase(value);
    }

    if (name === "phone") {
      if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, phone: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: orgJson.error.phone,
        }));
      }
    }
    if (name === "email") {
      if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, email: "" }));
      } else {
        setErrors((prev) => ({ ...prev, email: orgJson.error.email }));
      }
    }
    if (name === "gstNumber") {
      if (!formattedValue || GST_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, gstNo: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          gstNo: orgJson.error.gst,
        }));
      }
    }
    if (name === "panNumber") {
      if (!formattedValue || PAN_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, panNo: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          panNo: orgJson.error.pan,
        }));
      }
    }

    if (name in formData.address) {
      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [name]: formattedValue,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
  };

  const handleChangeAdditional = (index, fieldValue, changeValue) => {
    const updatedFields = additionalField.map((item, i) => {
      if (i === index) {
        return { lab: fieldValue, val: changeValue };
      }
      return item;
    });
    setAdditionalField(updatedFields);
  };
  const handleFileChange = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size < 1 * 1024 * 1024) {
        setSelectedFile(e.target.files[0]);
        setFileName(e.target.files[0]?.name)
      } else {
        addToast("Please attach file less then 1Mb", { appearance: "warning" });
      }
    }
  };

  const handleAddField = () => {
    const data = [...additionalField];
    data.push({
      lab: "",
      val: "",
    });
    setAdditionalField(data);
  };

  const handleCreateOrganization = (data) => {
    loading(true);
    dispatch(fetchAsyncCreateOrganization(data))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.orgSaved, { appearance: "success" });
          handleRefresh();
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
        loading(false);
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
        loading(false);
      });
  };

  const handleUpdateOrganization = (data) => {
    const id = editItem && editItem?.length && editItem[0]?._id;
    loading(true);

    dispatch(fetchAsyncUpdateOrganizaion({ id: id, data: data }))
      .then((res) => {
        if (res?.payload) {
          addToast(orgJson.success.orgUpdated, { appearance: "success" });
          handleRefresh();
        }
        loading(false);
      })
      .catch((err) => {
        addToast(orgJson.error.generic, { appearance: "error" });
        loading(false);
      });
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (validate()) {
      const formDataToSend = new FormData();
      const filteradditionalField = additionalField.filter((item)=> item.val)
      formDataToSend.append("additionalField", JSON.stringify(filteradditionalField));
      formDataToSend.append("file", selectedFile);
      formDataToSend.append("formdata", JSON.stringify(formData));

      if (editItem && editItem?.length) {
        handleUpdateOrganization(formDataToSend);
      } else {
        handleCreateOrganization(formDataToSend);
      }
    } else {
      const element = document.getElementById("organizationForm");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }
  };

  const handleCancel = (e) => {
    handleRefresh();
    setErrors({});
    const element = document.getElementById("organizationForm");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  const handleDeleteAddtionalField = (e, index, item) => {
    e.preventDefault();
    const confirmationMessage = orgJson.confirm.filed;
    const title = confirmationMessage.replace("{itemField}", item?.lab);
    ConfirmationDialog({
      title: title,
      text: "",
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        const updatedFields = additionalField.filter((_, i) => i !== index);
        setAdditionalField(updatedFields);
      },
    });
  };

  return (
    <>
      <div className="">
        <Form className="addForm mt-0">
          <Box className="form-group">
            <Box className="logo">
              <Text className="logo-heading">Organization Logo</Text>
            </Box>
            <Box
              display="flex"
              className="input-file-box"
              id="organizationForm"
            >
              <div>
                <Box className="logo-uploade">
                  <div className="uploade-btn">
                    <button class="btn file-uploade" type="button">
                      <input
                        id="ember1586"
                        title=""
                        accept="image/*"
                        className="upload ember-view"
                        type="file"
                        onChange={handleFileChange}
                      />
                      <Box display="flex" className="text1">
                        <AiOutlineUpload size={18} className="up-icon" />
                        Upload Your Organization Logo
                      </Box>
                    </button>
                  </div>
                </Box>
                <Text className="file-name">{fileName}</Text>
              </div>

              <Box className="uploade-dis">
                <label className="label">{orgJson.text.logoText}</label>
                <p className="text-muted">{orgJson.text.logoImage}</p>
              </Box>
            </Box>
          </Box>
          <hr className="hr-6" />
          <div className="form-box mt-3">
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label>
                  <span className="required">Organization Name*</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <InputFormControl
                  name="organizationName"
                  value={formData?.organizationName}
                  handleChange={handleChange}
                  isDisabled={isEditForm}
                />
                {errors?.organizationName && (
                  <p className="form_error">{errors?.organizationName}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span className="required">Industry*</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <SelectField
                  customClass="min-width-100"
                  value={formData?.industry?.value}
                  handleChange={(e) => {
                    const selectedType = industryType.find(
                      (item) => item?.value === e?.target?.value
                    );
                    setFormData({
                      ...formData,
                      industry: selectedType,
                    });
                  }}
                  options={industryType}
                />
                {errors?.industry && (
                  <p className="form_error">{errors?.industry}</p>
                )}
              </Col>
            </Row>

            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span className="">Organization Address </span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <InputFormControl
                  name="street1"
                  placeholder="Street 1"
                  value={formData?.address?.street1}
                  handleChange={handleChange}
                />
                <InputFormControl
                  name="street2"
                  customClass="mt-2"
                  placeholder="Street 2"
                  value={formData?.address?.street2}
                  handleChange={handleChange}
                />
                <Box display="flex">
                  <SelectField
                    value={formData?.address?.state?.id}
                    customClass="input1 mt-3"
                    handleChange={(e) => {
                      const selectedState = stateList?.find(
                        (item) => item?.id == e.target.value
                      );
                      handleStateChange(selectedState);
                    }}
                    options={stateList}
                    isId={true}
                  />
                  <InputFormControl
                    customClass="input1 mt-3"
                    name="zipcode"
                    placeholder="ZIP/Postal Code"
                    value={formData?.address?.zipcode || ""}
                    handleChange={handleChange}
                  />
                </Box>
                <Box display="flex">
                  <SelectField
                    value={formData?.address?.city?.id}
                    customClass="input1 mt-3"
                    handleChange={(e) => {
                      const selectedCity = cityList?.find(
                        (item) => item?.id == e.target.value
                      );
                      setFormData((prev) => ({
                        ...prev,
                        address: {
                          ...prev?.address,
                          city: selectedCity,
                        },
                      }));
                    }}
                    options={cityList}
                    isId={true}
                  />

                  <InputFormControl
                    customClass="input2 mt-3"
                    name="phone"
                    placeholder="Phone"
                    value={formData?.address?.phone || ""}
                    handleChange={handleChange}
                    isInvalid={errors?.phone}
                  />
                </Box>
                <InputFormControl
                  customClass="mt-3"
                  name="email"
                  placeholder="Email"
                  value={formData?.address?.email}
                  handleChange={handleChange}
                />
                {errors?.email && <p className="form_error">{errors?.email}</p>}
              </Col>
            </Row>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span>Website URL</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <InputFormControl
                  name="website"
                  value={formData?.website}
                  handleChange={handleChange}
                />
              </Col>
            </Row>
          </div>
          <hr className="hr-6" />
          <div className="form-box mt-3">
            <h4 className="logo-heading">Primary Contact</h4>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span className="">Company ID</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <Box display="flex">
                  <SelectField
                    value={formData?.companyType?.value}
                    handleChange={(e) => {
                      const selectedType = companyIdOption.find(
                        (item) => item?.value === e?.target?.value
                      );
                      setFormData({
                        ...formData,
                        companyType: selectedType,
                      });
                    }}
                    options={companyIdOption}
                  />
                  <InputFormControl
                    customClass="input2"
                    name="companyId"
                    value={formData.companyId}
                    handleChange={handleChange}
                  />
                </Box>
              </Col>
            </Row>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span className="">Tax ID</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <Box display="flex">
                  <InputFormControl
                    customClass="input2 disabled-field"
                    name="gstType"
                    placeholder="gstType"
                    value="GST"
                    isDisabled={true}
                  />
                  <InputFormControl
                    customClass="input2 disabled-field"
                    name="gstNumber"
                    disabled
                    placeholder="GST Number"
                    value={formData.gstNumber}
                    handleChange={handleChange}
                    isDisabled={true}
                  />
                </Box>
                {errors?.gstNumber && (
                  <p className="form_error">{errors?.gstNumber}</p>
                )}
              </Col>
            </Row>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span>Place Of Service</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <VendorCustomSelect
                  options={indiaStateOptions}
                  placeHolder=""
                  handleChange={(newValue) => {
                    setFormData({
                      ...formData,
                      placeOfService: newValue,
                    });
                  }}
                  isSearchable
                  defaultValue={formData?.placeOfService}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-lg-3 col-form-label">
                <Form.Label className="red">
                  <span>Pan Number</span>
                </Form.Label>
              </Col>
              <Col className="col-lg-6">
                <InputFormControl
                  customClass="disabled-field"
                  name="panNumber"
                  isDisabled={true}
                  value={formData?.panNumber}
                  handleChange={handleChange}
                />
                {errors?.panNumber && (
                  <p className="form_error">{errors?.panNumber}</p>
                )}
              </Col>
            </Row>
          </div>
          <hr className="hr-6" />
          <div className="form-box mt-0">
            <h4 className="logo-heading">Purchase Order</h4>
            <span className="label">Terms & Conditions</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={4}
                name="termsAndConditions"
                value={formData?.termsAndConditions}
                handleChange={handleChange}
                placeholder={orgJson.text.tc}
                customClass="terms_textarea"
              />
            </div>
          </div>
          <div className="form-box mt-2">
            <span className="label">Footer Text</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={2}
                name="footerText"
                value={formData?.footerText}
                handleChange={handleChange}
                placeholder={orgJson.text.fTxt}
                customClass="terms_textarea"
              />
            </div>
          </div>
          <hr className="hr-6" />
          <h4 className="logo-heading">Sales Invoice</h4>
          <h6 className="sub-heading">
            Tax Invoice
            <CustomPopover popoverText={orgJson.text.sText} />
          </h6>

          <div className="form-box mt-0">
            <span className="label">Terms & Conditions</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={4}
                name="salesTC"
                value={formData?.salesTC}
                placeholder={orgJson.text.sTc}
                customClass="terms_textarea"
                handleChange={handleChange}
              />
            </div>
          </div>
          <div className="form-box mt-2">
            <span className="label">Footer Text</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={2}
                value={formData?.salesFooterText}
                name="salesFooterText"
                placeholder={orgJson.text.sFtxt}
                customClass="terms_textarea"
                handleChange={handleChange}
              />
            </div>
          </div>
          <h6 className="sub-heading mt-3">
            Proforma Invoice
            <CustomPopover popoverText={orgJson.text.pfText} />
          </h6>
          <div className="form-box mt-0">
            <span className="label">Terms & Conditions</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={4}
                name="proformaTC"
                value={formData?.proformaTC}
                placeholder={orgJson.text.pfTc}
                customClass="terms_textarea"
                handleChange={handleChange}
              />
            </div>
          </div>
          <div className="form-box mt-2">
            <span className="label">Footer Text</span>
            <div className="col-lg-10 mt-2">
              <TextAreaField
                rows={2}
                value={formData?.proformaFooterText}
                name="proformaFooterText"
                placeholder={orgJson.text.pfFtxt}
                customClass="terms_textarea"
                handleChange={handleChange}
              />
            </div>
          </div>
          <h6 className="sub-heading mt-3">
            Bank Details
            <CustomPopover popoverText={orgJson.text.bankTxt} />
          </h6>
          <div className="form-box">
            <CheckboxField
              customClass="mt-2"
              name="isBnk"
              isChecked={formData?.isBnk}
              handleChange={handleChangeBank}
              label="Do You want to show bank details into invoice?"
            />
            {/* {formData?.isBnk && (
              <>
                <Box className="d-flex mt-2">
                  <RadioField
                    name="typ"
                    value="auto"
                    isChecked={formData?.bnk?.typ === "auto"}
                    handleChange={handleChangeBank}
                    label="Automated"
                  />
                  <RadioField
                    customClass="mx-3"
                    name="typ"
                    value="manual"
                    isChecked={formData?.bnk?.typ === "manual"}
                    handleChange={handleChangeBank}
                    label="Manual"
                  />
                </Box>
                {formData?.bnk?.typ === "manual" && (
                  <div className="form-box mt-0">
                    <Row className="mt-2">
                      <Col className="col-5">
                        <Form.Label className="red">
                          <span className="label">Account Holder</span>
                        </Form.Label>
                        <InputFormControl
                          name="hol"
                          placeholder="Account Holder"
                          value={formData?.bnk?.hol}
                          handleChange={handleChangeBank}
                        />
                      </Col>
                      <Col></Col>
                    </Row>
                    <Row className="mt-2">
                      <Col className="col-5">
                        <Form.Label className="red">
                          <span className="label">Account Number</span>
                        </Form.Label>
                        <InputFormControl
                          name="acNo"
                          placeholder="Account Number"
                          value={formData?.bnk?.acNo}
                          handleChange={handleChangeBank}
                        />
                        {errors?.acNo && (
                          <p className="form_error">{errors?.acNo}</p>
                        )}
                      </Col>
                      <Col className="col-5">
                        <Form.Label className="red">
                          <span className="label">IFSC Code</span>
                        </Form.Label>
                        <InputFormControl
                          name="ifc"
                          placeholder="Ifsc Code"
                          handleBlur={handleBlur}
                          value={formData?.bnk?.ifc}
                          handleChange={handleChangeBank}
                        />
                        {errors?.ifc && (
                          <p className="form_error">{errors?.ifc}</p>
                        )}
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col className="col-5">
                        <Form.Label className="red">
                          <span className="label">Bank Name</span>
                        </Form.Label>
                        <InputFormControl
                          name="name"
                          placeholder="Bank Name"
                          value={formData?.bnk?.name}
                          handleChange={handleChangeBank}
                        />
                      </Col>
                      <Col className="col-5">
                        <Form.Label className="red">
                          <span className="label">Branch Name</span>
                        </Form.Label>
                        <InputFormControl
                          name="bch"
                          placeholder="Branch Name"
                          value={formData?.bnk?.bch}
                          handleChange={handleChangeBank}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </>
            )} */}
          </div>
          <hr className="hr-6" />
          <div className="form-box mt-3">
            <h4 className="heading2">Additional Fields</h4>
            <Row>
              <Col className="col-lg-9">
                <Table className="field-table">
                  <Thead>
                    <Tr>
                      <Th>Lable Name</Th>
                      <Th>Value</Th>
                      <Th className="action-heading">Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {additionalField && additionalField?.length
                      ? additionalField?.map((item, index) => {
                          return (
                            <Tr>
                              <Td>
                                <div>
                                  <InputFormControl
                                    name={`label${index}`}
                                    placeholder="Label"
                                    value={item?.lab}
                                    handleChange={(e) =>
                                      handleChangeAdditional(
                                        index,
                                        e.target?.value,
                                        item.val
                                      )
                                    }
                                  />
                                </div>
                              </Td>
                              <Td>
                                <InputFormControl
                                  name={`value${index}`}
                                  placeholder="Value"
                                  value={item?.val}
                                  handleChange={(e) =>
                                    handleChangeAdditional(
                                      index,
                                      item?.lab,
                                      e.target.value
                                    )
                                  }
                                />
                              </Td>
                              <Td>
                                <AiFillDelete
                                  style={{
                                    cursor: "pointer",
                                    color: "#c3473e",
                                    marginLeft: "12px",
                                  }}
                                  size={16}
                                  onClick={(e) => {
                                    handleDeleteAddtionalField(e, index, item);
                                  }}
                                />
                              </Td>
                            </Tr>
                          );
                        })
                      : ""}
                  </Tbody>
                </Table>
                <Box display="flex" alignItems="center" className="mt-3">
                  <Button
                    className="add-project mt-2 mx-0"
                    onClick={() => handleAddField()}
                    minWidth={0}
                  >
                    <FaPlusCircle className="add-project-icon" size={18} />
                    <Text className="mx-3 heading2">Add Additional Field</Text>
                  </Button>
                </Box>
              </Col>
            </Row>
          </div>
          <hr className="hr-6" />
          <Box className="btn-footer">
            <Button onClick={(e) => handleSave(e)} className="btn save-btn">
              Save
            </Button>
            <Button className="btn cancel-btn" onClick={(e) => handleCancel(e)}>
              Cancel
            </Button>
          </Box>
        </Form>
      </div>
    </>
  );
};

export default OrgnizationProfileForm;
